module.exports = __webpack_public_path__ + "static/media/logo.4cdef3a7.png";